<template>
    <div>
        <div class="block-container">
            <div class="swb-back-row">
                <div class="order-search-container">
                    <a class="all-order">全部派工单</a>
                </div>

                <div class="orders-list-container">
                    <table class="orders-list-panel1">
                        <colgroup>
                            <col width="500px">
                            <col width="300px">
                            <col width="200px">
                            <col width="200px">
                            <col width="200px">
                        </colgroup>
                        <thead class="orders-header">
                        <tr class="">
                            <th>
                                <span>服务名称</span>
                                <!--<span class="fr" style="padding-right: 35px">金额(元)</span>-->
                            </th>
                            <th>主工程师</th>
                            <th>预约上门日期</th>
                            <th>状态</th>
                            <th>是否评价</th>
                        </tr>
                        </thead>
                        <tbody class="orders-body" v-for="servcWorkVoucher in servcWorkVoucherList">
                        <tr class="blank-row">
                            <td colspan="5"></td>
                        </tr>
                        <tr class="abstract-row">
                            <td colspan="5">
                                <div class="abstract-content">
                                    <span class="mr30">派工单号：<a>{{servcWorkVoucher.no}}</a></span>
                                    <span class="mr30">卖家公司名称：<a>{{servcWorkVoucher.servicerName}}</a></span>
                                </div>
                                <div v-if="servcWorkVoucher.requestProxied" class="table-tips order"></div>
                            </td>
                        </tr>
                        <tr class="info-row">
                            <td>
                                <div class="goods-info-block"> <!--v-for="servcOrderItem in servcWorkVoucher.servcOrderItemList"-->
                                    <div class="goods-item clearfix">
                                        <div class="good-img">
                                            <img :src="servcWorkVoucher.servcFileBrowseUrl"/>
                                        </div>
                                        <div class="good-msg">
                                            <p class="ellipsis-2 font12">{{servcWorkVoucher.servcTitle}}</p>
                                        </div>
                                    </div>
                                    <!--<div class="goods-number font-gray1">¥<b class="pri">{{servcOrderItem.toDoorFee}}</b></div>-->
                                    <div class="clr"></div>
                                </div>
                            </td>
                            <td>
                                <div class="clearfix" v-if="servcWorkVoucher.servicerEngineer != null">
                                    <div class="good-img">
                                        <img :src="servcWorkVoucher.servicerEngineer.fileBrowseUrl"/>
                                    </div>
                                    <div class="">
                                        <p class="ellipsis-2 font12">{{servcWorkVoucher.engineerName}}</p>
                                        <p class="ellipsis-2 font12">{{servcWorkVoucher.servicerEngineer.contactTel}}</p>
                                    </div>
                                </div>
                                <div class="clearfix" v-else>
                                    <p class="font12 align-center font-red">待指派工程师</p>
                                </div>
                            <td>
                                <p>
                                    <el-tag v-if="servcWorkVoucher.beyondWrnt" type="danger">交易约定外</el-tag>
                                    <el-tag type="success" v-else>交易约定内</el-tag>
                                </p>
                                <p class="font-gray1">{{servcWorkVoucher.planTime}}</p>
                            </td>
                            <td>
                                <p v-if="servcWorkVoucher.invalid" class="font-red">已作废</p>
                                <p v-else-if="servcWorkVoucher.closed" class="font-red">已关闭</p>
                                <p v-else-if="!servcWorkVoucher.invalid">{{servcWorkVoucher.stateText}}</p>
                                <p v-if="servcWorkVoucher.stateText == '服务暂停'" class="font-red">原因：{{servcWorkVoucher.stateDesc}}</p>
                                <p v-if="servcWorkVoucher.stateText == '已拒接'" class="font-red">拒接原因：{{servcWorkVoucher.refuseCause}}</p>
                                <a class="swb-btn-link" v-if="checkActionPerm('view_charge_item')" @click="toChargeItems(servcWorkVoucher.id)">查看收费项</a>
                                <a class="swb-btn-link" @click="toWorkVoucherDetail(servcWorkVoucher.id)">查看详情</a>
                                <a class="swb-btn-link" @click="toWorkVoucherRecs(servcWorkVoucher.id)">查看操作记录</a>
                                <a class="swb-btn-link" v-if="servcWorkVoucher.stateText == '验收完成' && !servcWorkVoucher.evalFlag" @click="toEvel(servcWorkVoucher.id)">评价</a>
                            </td>
                            <td>
                                <p v-if="servcWorkVoucher.evalFlag" class="font-green">已评价</p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    import { checkUserActionPerm } from '../index'
    import { openWorkVoucherDetailDlg } from './showDetailDlg'
    import { openWorkVoucherRecsDlg } from './showDetailDlg'

    import servcDelivApi from '../../api/servcDeliv'

    // 订单收费项
    import SwbServcOrderChargeItemList from './ServcOrderChargeItemList';
    Vue.regist(SwbServcOrderChargeItemList);

    import SwbOrderServcEval from './OrderServcEval';
    Vue.regist(SwbOrderServcEval);

    export default {
        name: 'swb-servc-work-voucher-of-order',
        desc: '派工单列表',
        props: ['orderId', 'selfPath'],
        data: function () {
            return {
                servcWorkVoucherList: [],
            }
        },
        created: function () {
            this.getServcWorkVoucherList();
        },
        methods: {
            // 检查资源具体操作权限（可选的是否为指定的岗位id）
            checkActionPerm: function (action, targetPostId) {
                return checkUserActionPerm(this.selfPath, action, targetPostId);
            },
            getServcWorkVoucherList: function () {
                let self = this;
                let postData = {};
                postData.orderId = self.orderId;
                servcDelivApi.getServcWorkVoucherList(postData, function (result) {
                    if(result.type == 'info') {
                        let servcWorkVoucherList = result.data;
                        if(!Utils.isNoB(servcWorkVoucherList) && servcWorkVoucherList.length > 0) {
                            for(let i = 0; i < servcWorkVoucherList.length; i++) {
                                let servcWorkVoucher = servcWorkVoucherList[i];
                                let stateInfo = getEnumInfoWith('workAssignState', 'value', servcWorkVoucher.state);
                                servcWorkVoucher.stateText = stateInfo.text;
                            }
                        }
                        self.servcWorkVoucherList = servcWorkVoucherList;
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 查看详情
            toWorkVoucherDetail: function (id) {
                openWorkVoucherDetailDlg(id);
            },
            // 查看操作记录
            toWorkVoucherRecs: function (id) {
                openWorkVoucherRecsDlg(id);
            },
            // 查看收费项
            toChargeItems: function (workId) {
                Vue.$showDialog({
                    title: '工单 - 查看收费项',
                    showCloseBtn: true,
                    cancelText: '关闭',
                    okVisible: false,
                    width: 600,
                    height: 420,
                    template: '<div>' +
                    '<swb-servc-order-charge-item-list :workId="workId" ref="swb_servc_order_charge_item_list"></swb-servc-order-charge-item-list>' +
                    '</div>',
                    data: {
                        workId: workId,
                    },
                    methods: {},
                    okClicked: function () {
                    },
                    lifecycle: {
                        created: function () {
                        }
                    }
                });
            },
            // 去评价
            toEvel(workId){
                let self = this;
                let theDlg = Vue.$showDialog({
                    title: '服务评价',
                    showCloseBtn: true,
                    okVisible: true,
                    width: 1200,
                    height: 710,
                    template: '<div>' +
                    '<swb-order-servc-eval :workId="workId" ref="swb_order_servc_eval"></swb-order-servc-eval>' +
                    '</div>',
                    data: {
                        workId: workId,
                    },
                    methods: {},
                    okClicked: function () {
                        let result = this.$refs.swb_order_servc_eval.getDlgResult() || {};
                        console.log(result);
                        if(result.type == 'info') {
                            // 保存评价
                            let theLoading = MsgBox.loading();
                            servcDelivApi.saveOrderServcEval(result.data, function (resultData) {
                                theLoading.close();
                                if(resultData.type == 'info') {
                                    if(resultData.data) {
                                        self.$message.success("评价成功");
                                        self.getServcWorkVoucherList();
                                        theDlg.close();
                                    } else {
                                        self.$message.success("评价失败");
                                    }
                                } else {
                                    MsgBox.warning(resultData.message);
                                }
                            });
                        } else {
                            self.$message.warning(result.message);
                        }
                        return false;
                    },
                    lifecycle: {
                        created: function () {
                        }
                    }
                });
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/workVoucher/ServcWorkVoucherOfOrder.vue